export const RECIPIENT_MAIN_INFO_SCREEN = 'RECIPIENT_MAIN_INFO_SCREEN';
export const CALCULATOR_SCREEN = 'CALCULATOR_SCREEN';
export const PAYMENT_METHOD_SCREEN = 'PAYMENT_METHOD_SCREEN';
export const SENDER_ADDITIONAL_INFO_SCREEN = 'SENDER_ADDITIONAL_INFO_SCREEN';
export const RECIPIENT_ADDITIONAL_INFO_SCREEN = 'RECIPIENT_ADDITIONAL_INFO_SCREEN';
export const TRANSFER_ADDITIONAL_INFO_SCREEN = 'TRANSFER_ADDITIONAL_INFO_SCREEN';
export const CARD_EXTRA_FIELDS_SCREEN = 'CARD_EXTRA_FIELDS_SCREEN';
export const LIBRE_SCREEN = 'LIBRE_SCREEN';
export const SUB_SOURCES_SCREEN = 'SUB_SOURCES_SCREEN';
export const FILL_PROFILE_SCREEN = 'FILL_PROFILE_SCREEN';
export const DETERMINE_SCREEN_WITH_ERROR = 'DETERMINE_SCREEN_WITH_ERROR';

// Field name constants for send screen machine
export const HAS_CARD_EXTRA_FIELDS = 'hasCardExtraFields';
export const HAS_SENDER_ADDITIONAL_FIELDS = 'hasSenderAdditionalFields';
export const HAS_RECIPIENT_ADDITIONAL_FIELDS = 'hasRecipientAdditionalFields';
export const HAS_TRANSFER_ADDITIONAL_FIELDS = 'hasTransferAdditionalFields';
export const HAS_SUB_SOURCES = 'hasSubSources';
export const RECIPIENT_NOT_SAVED = 'recipientNotSaved';
export const SHOW_CALCULATOR_FIRST = 'showCalculatorFirst';
